import gql from "graphql-tag"
import { useMutation } from "react-apollo"
import { ROOT_QUERY_USER_FRAGMENT, ROOT_QUERY } from "graphql/queries/user"
import {
  CoveSignInViaReturningHashMutation,
  CoveSignInViaReturningHashMutationVariables,
  RootQuery,
  RootQueryVariables
} from "typings/types"

export const SIGN_IN_VIA_RETURNING_HASH_MUTATION = gql`
  mutation CoveSignInViaReturningHash($returningHash: String!) {
    user: signInViaReturningHash(returningHash: $returningHash) {
      ...RootQueryUserFragment
    }
  }
  ${ROOT_QUERY_USER_FRAGMENT}
`

/*
  In order for the writeQuery to work correctly and propagate cache updates to the useQuery hooks
  we MUST return ALL of the fields on the user that are queried in the ROOT_QUERY
*/
export const useSignInViaReturningHashMutation = () =>
  useMutation<CoveSignInViaReturningHashMutation, CoveSignInViaReturningHashMutationVariables>(
    SIGN_IN_VIA_RETURNING_HASH_MUTATION,
    {
      update: (cache, { data }) => {
        const prevData = cache.readQuery<RootQuery, RootQueryVariables>({ query: ROOT_QUERY })
        if (!prevData) {
          throw new Error("Unexpected: root query should have been loaded.")
        }

        if (data) {
          cache.writeQuery({
            query: ROOT_QUERY,
            data: {
              ...prevData,
              user: { ...data.user, __typename: "User" }
            }
          })
        }
      }
    }
  )
